import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminUser(props) {
    const formuserRef = useRef(null)
    const usernameRef = useRef(null)

    const [sitelist_ref, setSitelist_ref] = useState([]);
    const [sitelist_selected, setSitelist_selected] = useState([]);
    const [userlist, setUserlist] = useState([]);
    const [useritem, setUseritem] = useState({
        id: 0,
        username: '',
        password: '',
        status: '',
        user_mode: '',
        user_role: '',
        firstname: '',
        lastname: '',
        scope: ''
    });
    const [mode, setMode] = useState('');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_user, setModal_user] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        api_delete(message)
    }

    function init_item() {
        setUseritem({
            id: 0,
            username: '',
            password: '',
            status: '',
            user_mode: '',
            user_role: '',
            firstname: '',
            lastname: '',
            scope: ''
        })
    }

    useEffect(() => {
        api_load()
        return () => {
            setSitelist_ref([])
            setSitelist_selected([])
            setUserlist([])
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading user list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/user/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.user !== undefined && response.data.user !== null) {
                    setUserlist(response.data.user)
                }
                if (response.data.sitelist !== undefined && response.data.sitelist !== null) {
                    setSitelist_ref(response.data.sitelist)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_load_by_id(id) {
        setmodal_load({ enable: true, message: "Loading user info." })
        await sleep(500)

        const formData = new FormData()
        formData.append('id', id)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/user/getuserinfo", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setMode('edit')
                    setModal_user(true)
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.user !== undefined && response.data.user !== null) {
                    setUseritem(response.data.user)
                }
                if (response.data.sitelist !== undefined && response.data.sitelist !== null) {
                    setSitelist_selected(response.data.sitelist)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_add() {
        const filteredArray = sitelist_selected.filter((item) => item.selected === true).map((item) => item.sitecode_txt);
        var formelement = formuserRef.current
        var username = usernameRef.current

        if (formelement.checkValidity() === false || username.value.toUpperCase() === "ADMIN") {
            if (username.value.toUpperCase() === "ADMIN") {
                username.setCustomValidity("x");
            }
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Adding user to a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('username', useritem.username)
            formData.append('password', useritem.password)
            formData.append('status', useritem.status)
            formData.append('user_mode', "-")
            formData.append('user_role', useritem.user_role)
            formData.append('firstname', useritem.firstname)
            formData.append('lastname', useritem.lastname)
            formData.append('scope', filteredArray.join("#"))
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/user/add", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_user(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your user has been added to a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.user !== undefined && response.data.user !== null) {
                        setUserlist(response.data.user)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_edit() {
        const filteredArray = sitelist_selected.filter((item) => item.selected === true).map((item) => item.sitecode_txt);
        var formelement = formuserRef.current
        var username = usernameRef.current

        if (formelement.checkValidity() === false || username.value.toUpperCase() === "ADMIN") {
            if (username.value.toUpperCase() === "ADMIN") {
                username.setCustomValidity("x");
            }
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Editing user in a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('id', useritem.id)
            formData.append('username', useritem.username)
            formData.append('password', useritem.password)
            formData.append('status', useritem.status)
            formData.append('user_mode', "-")
            formData.append('user_role', useritem.user_role)
            formData.append('firstname', useritem.firstname)
            formData.append('lastname', useritem.lastname)
            formData.append('scope', filteredArray.join("#"))
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/user/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_user(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your user has been edited in a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.user !== undefined && response.data.user !== null) {
                        setUserlist(response.data.user)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_delete(item) {
        setmodal_load({ enable: true, message: "Deleting user in a database." })
        await sleep(500)

        const formData = new FormData();
        formData.append('id', item.id)
        formData.append('scope', item.scope)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/user/delete", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your user has been deleted in a database.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.user !== undefined && response.data.user !== null) {
                    setUserlist(response.data.user)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    function checkEnable(status) {
        if (status === 'Enable') {
            return <td><i className="far fa-check-circle icon-green"></i> {status}</td>
        }
        else {
            return <td><i className="far fa-circle"></i> {status}</td>
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-users-cog"></i> Users Authentication</h4>
                                    <p className="mb-0">Manage all users authentication</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-warning btn-sm" onClick={() => {
                                    setMode('add')
                                    setSitelist_selected(sitelist_ref)
                                    setUseritem({
                                        id: 0,
                                        username: '',
                                        password: '',
                                        status: 'Enable',
                                        user_mode: 'center',
                                        user_role: 'Viewer',
                                        firstname: '',
                                        lastname: '',
                                        scope: '-'
                                    })
                                    setModal_user(true)
                                }}><i className="fas fa-plus"></i> Add New</button>
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Users Table (Found {userlist.length} Users)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>#</th>
                                        <th>Username</th>
                                        <th>Status</th>
                                        <th>User Mode</th>
                                        <th>User Role</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Total Sites Scope</th>
                                        <th>Edit Time</th>
                                        <th className="text-center" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        userlist?.map((user, index) => (
                                            <tr key={user.id}>
                                                <td> {index + 1}</td>
                                                <td><i className="fas fa-user-shield rows-icon"></i> {user.username}</td>
                                                {checkEnable(user.status)}
                                                <td>{user.user_mode}</td>
                                                <td>{user.user_role}</td>
                                                <td>{user.firstname}</td>
                                                <td>{user.lastname}</td>
                                                <td>{user.user_role === "Admin" ? "All" : user.total_scope} Sites</td>
                                                <td>{user.edittime}</td>
                                                <td>
                                                    <Link className="btn btn-icon btn-sm btn-warning btn-hover btn-bordered" title="Edit" onClick={() => { api_load_by_id(user.id) }}><i className="fas fa-pen"></i></Link>
                                                    <Link className="btn btn-icon btn-sm btn-danger btn-hover btn-bordered mx-1" title="Delete" onClick={() => {
                                                        setModal_popup({
                                                            modaltype: 'modal-confirm',
                                                            headers: 'Confirmation',
                                                            message: "Please click on confirm button to continue this operation.",
                                                            enable: true,
                                                            confirmcode: user,
                                                        });
                                                    }}><i className="fas fa-eraser"></i></Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>


                    {
                        modal_user ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-xl modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-users-cog"></i> {mode === "add" ? "Add" : "Edit"} User Authentication</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_user(false); setSitelist_selected([]) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formuserRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="username">Username</label>
                                                                <input type="text" className="form-control" name="username" ref={usernameRef} value={useritem.username} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        username: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="password">Password</label>
                                                                <input type="password" className="form-control" name="password" pattern=".{4,}" value={useritem.password} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        password: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="firstname">First name</label>
                                                                <input type="text" className="form-control" name="firstname" value={useritem.firstname} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        firstname: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="lastname">Last name</label>
                                                                <input type="text" className="form-control" name="lastname" value={useritem.lastname} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        lastname: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <label htmlFor="user_role">User Role</label>
                                                            <select name="user_role" className="form-select" value={useritem.user_role} onChange={(e) => {
                                                                setUseritem({
                                                                    ...useritem,
                                                                    user_role: e.target.value
                                                                })
                                                            }} required>
                                                                <option value="Viewer">Viewer</option>
                                                                <option value="Operator">Operator</option>
                                                                <option value="Admin">Admin</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="status">Status</label>
                                                            <select name="status" className="form-select" value={useritem.status} onChange={(e) => {
                                                                setUseritem({
                                                                    ...useritem,
                                                                    status: e.target.value
                                                                })
                                                            }} required>
                                                                <option value="Enable">Enable</option>
                                                                <option value="Disable">Disable</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        {
                                                            useritem.user_role !== "Admin" ?
                                                                <React.Fragment>
                                                                    <h6>Site Scope Selector</h6>
                                                                    <div className='d-flex flex-wrap gap-2'>
                                                                        {
                                                                            sitelist_selected?.map((site, index) => (
                                                                                <div className="form-check" key={"sn-" + index} style={{ width: "320px" }}>
                                                                                    <input className="form-check-input" type="checkbox" name={"pv" + index} checked={site.selected} onChange={(e) => {
                                                                                        const nextCounters = sitelist_selected?.map((c, i) => {
                                                                                            if (i === index) {
                                                                                                return { ...c, selected: e.target.checked }
                                                                                            } else {
                                                                                                return c;
                                                                                            }
                                                                                        });
                                                                                        setSitelist_selected(nextCounters)
                                                                                    }} />
                                                                                    <label htmlFor={"pv" + index} className="form-check-label font-sarabun">
                                                                                        {site.sitecode_txt}  {site.sitename_th}
                                                                                    </label>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </React.Fragment>
                                                                :
                                                                null
                                                        }

                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_user(false); setSitelist_selected([]) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { { mode === "add" ? api_add() : api_edit() } }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminUser